import { render, staticRenderFns } from "./AveragesTable.vue?vue&type=template&id=8a68c222&scoped=true&"
import script from "./AveragesTable.vue?vue&type=script&lang=js&"
export * from "./AveragesTable.vue?vue&type=script&lang=js&"
import style0 from "./AveragesTable.vue?vue&type=style&index=0&id=8a68c222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a68c222",
  null
  
)

export default component.exports